<template>
  <div class="flex-center fixed-0 bgs-[url('@/assets/images/bg_maintain.jpg'),center] bg-[#151A1F]">
  </div>
</template>

